/**
 * SalesToggle Component
 * 
 * Toggle between "Detalle" (mesa view) and "Comandas" (comandas view)
 */

import React from 'react';
import { FaListCheck, FaReceipt } from 'react-icons/fa6';
import { VIEW_MODES, type ViewMode } from '../../utils';
import './SalesToggle.scss';

interface SalesToggleProps {
  viewMode: ViewMode;
  onViewChange: (mode: ViewMode) => void;
}

const SalesToggle: React.FC<SalesToggleProps> = ({ viewMode, onViewChange }) => {
  return (
    <div className="sales-view-selector">
      <button
        onClick={() => onViewChange(VIEW_MODES.MESA)}
        className={`view-selector-tab ${viewMode === VIEW_MODES.MESA ? 'active' : ''}`}
      >
        <FaListCheck className='selector-icon' /> Detalle
      </button>
      <button
        onClick={() => onViewChange(VIEW_MODES.COMANDAS)}
        className={`view-selector-tab ${viewMode === VIEW_MODES.COMANDAS ? 'active' : ''}`}
      >
        <FaReceipt className='selector-icon' /> Comandas
      </button>
    </div>
  );
};

export default SalesToggle;
